import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'EQ 4 – Relationship Management',
  slug: 'eq-4-relationship-management',
  category: 'EQ',
  date: '2025-05-16',
  image: '',
  excerpt: 'This uses all of the previous skills to elegantly work with others.',
  body: `Relationship Management uses the previous three competencies to build relationships and is the ultimate usage of emotional intelligence. It is the ability to work with all kinds of people in all kinds of situations. Some ideas…

1. Be curious. Really desire to know about the other person. This helps EVERYTHING – from being a friend to being able to serve a client better.
2. Know your style. How do you best communicate? Directly? Controlled? Serious? Comfortable? Chatty? Thoughtfully? Intensely? Intrusively? Now, what are the pros & cons of your style? Get the journal out.
3. Please. Thank you. I'm sorry. These things matter.
4. Take feedback with grace and curiosity. Even if from an adversary, there's a lot of growth opportunities in things that make you upset.
5. Build trust. Be impeccable with your word. Keep good lines of communication. Be reliable.
6. Be open to questions. Let people feel comfortable asking you for help.
7. Acknowledge the other person's emotional state. It will help them trust you.
8. If you care, let the person know. It's a small thing that makes a huge difference.
9. Make your actions understood. Be sure to explain why you are making the decisions you are, especially when the stakes are high. Builds trust.
10. Get to the point and make sure any feedback you give has actionable suggestions.
11. If you are faced with a tough conversation:

- Start with common ground. Facts, intentions, goals. This is the safe space.
- Ask the other person to help you understand their point of view. It builds trust AND you need to know this stuff to proceed.
- Listen. Don't give a quick comeback or slap-down. Pay attention to the other person.
- Only after you've given the other person a chance to tell their story, offer yours. Be able to verbalize your position succinctly, elegantly, and graciously.
- Moving forward, look back to the common ground and see how you might further the common ground between your two positions.
- Follow up after the conversation. Keep after it until you reach a conclusion.
- Be gracious. Be willing to take the high road. If you've listened and have been heard, you still might not get what you want. Rest in the knowledge you did the work.`,
}

export default post
